export class RespBenefits {
  accountNumber: string;
  tier: string;
  tierBenefits:tierBenefits;
  cobrandCode: string;
  details: string;
  cobrandBenefits: cobrandBenefits;
  ffBenefits: ffBenefits;
  isNotFirstBaggage: boolean;
  warnings: any

  constructor(obj) {
    this.accountNumber = obj?.accountNumber;
    this.tier = obj?.tier;
    this.tierBenefits = obj?.tierBenefits;
    this.cobrandCode = obj?.cobrandCode;
    this.details = obj?.details;
    this.cobrandBenefits = obj?.cobrandBenefits;
    this.ffBenefits = obj?.['f&fBenefits'];
    this.warnings = obj?.warnings;
    this.isNotFirstBaggage = obj?.isNotFirstBaggage ?? obj?.isNotFirstBagagge ?? false;
  }
}

export class tierBenefits {
  baggage: boolean;
  sportEquipment: boolean;
  seats:seats;
}

export class seats {
  amPlus: boolean;
  preferent: boolean;
  exitRow: boolean;
  tourist: boolean;
}

export class cobrandBenefits {
  baggage: boolean;
  carryOn: boolean;
}

export class ffBenefits {
  baggage: boolean;
  sportEquipment: boolean;
  seats:seats;
}
